import React, { useContext } from "react";
import { RendouSet, Rotate1Set, Rotate2Set, SyukurenSet } from "../App";

export const ButtonRotate = (props) => {
  const { rotate1set, setRotate1Set } = useContext(Rotate1Set);
  const { rotate2set, setRotate2Set } = useContext(Rotate2Set);
  const { rendouset, setRendouSet } = useContext(RendouSet);
  const { syukurenset, setSyukurenSet } = useContext(SyukurenSet);

  const rotate_on = () => {
    if (rotate1set) {
      setRotate1Set(false);
      setRotate2Set(false);
      setRendouSet(true);
    } else {
      setRendouSet(false);
      setSyukurenSet(false);
      setRotate1Set(true);
      setRotate2Set(true);
    }
  };

  return (
    <>
      <main className="flex items-center justify-center m-2">
        <div
          className="flex md:rounded-xl bg-gray-200 p-1 pointer-events-auto"
          x-data="app"
        >
          <input
            name="rotate"
            id="回転"
            type="checkbox"
            // value="回転"
            onChange={rotate_on}
            checked={true == rotate1set}
            className="peer hidden"
          />
          <label
            htmlFor="回転"
            className="block cursor-pointer select-none md:rounded-xl md:px-3 md:py-2 text-center text-xs md:text-base peer-checked:bg-blue-500 peer-checked:text-white"
          >
            <div className="z-10">
              <svg
                className="w-6 h-6 mx-auto"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                ></path>
              </svg>
            </div>
          </label>
        </div>
      </main>
    </>
  );
};
